import { render } from "./TableRowMenu.vue?vue&type=template&id=01465aac"
import script from "./TableRowMenu.vue?vue&type=script&lang=ts"
export * from "./TableRowMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script